import { ClipboardFormats } from "./ClipboardFormats";
import { CREATEJS_UTILITIES_LOGGER } from "../../../../..";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".Clipboard");

export class Clipboard {
    private static _clipboard: Clipboard;
    private _data: any;
    private _textElement: HTMLTextAreaElement;

    public readonly formats: ClipboardFormats[];
    public static readonly SURROGATE  = "clipboardSurrogateTextArea";

    constructor() {
        // add fake textarea
        this._textElement = document.createElement("textarea");
        this._textElement.id = Clipboard.SURROGATE;
        // Prevent zooming on iOS
        this._textElement.style.fontSize = "12pt";
        // Reset box model
        this._textElement.style.border = "0";
        this._textElement.style.padding = "0";
        this._textElement.style.margin = "0";
        // Move element out of screen horizontally
        this._textElement.style.position = "absolute";
        this._textElement.style.right = "-9999px";
        // Move element to the same position vertically
        let yPosition = window.pageYOffset || document.documentElement.scrollTop;
        this._textElement.style.top = `${yPosition}px`;

        this._textElement.setAttribute("readonly", "");
        this._textElement.addEventListener("fakeClick", this.execCopy);

        document.body.appendChild(this._textElement);
    }

    public static get generalClipboard(): Clipboard {
        if (!this._clipboard) {
            this._clipboard = new Clipboard();
        }
        return this._clipboard;
    }

    public static set generalClipboard(clipBoard: Clipboard) {
        throw new TypeError("generalClipboard is readonly");
    }

    public setData(format: ClipboardFormats, data: any, serializable: boolean = true): boolean {
        this._data = data;
        this._textElement.value = data;

        this._textElement.select();
        document.execCommand("copy");

        return true;
    }

    public getData(format: ClipboardFormats): any {
        return this._data;
    }

    public clear(): void {
        this.setData(ClipboardFormats.TEXT_FORMAT, "");
    }

    private execCopy(): boolean {
        try {
            return document.execCommand("copy");
        } catch (e) {
            logger.error("[Clipboard]: execCommand copy failed");
            return false;
        }
    }
}
